export const firebaseConfig = {
  apiKey: "AIzaSyAtLpcvpDUG7OQsl8uAxX4yEcoqtVpGpu0",
  authDomain: "sea-frozen-qa-app.firebaseapp.com",
  databaseURL: "https://sea-frozen-qa-app.firebaseio.com",
  projectId: "sea-frozen-qa-app",
  storageBucket: "sea-frozen-qa-app.appspot.com",
  messagingSenderId: "786242176235"
}

export const FUNCTIONS_END_POINT_URL = 'https://us-central1-sea-frozen-qa-app.cloudfunctions.net';



// WEBPACK FOOTER //
// ./src/config/firebase-config.ts